import React from 'react';

import { H4, H6, Icon } from '@blueprintjs/core';
import { ReactComponent as SearchResultPOIMarker } from '../img/marker.svg';

interface Props {
  address_to_address: AddressToAddressSearchResults;
}

const AddressToAddressInfo: React.FC<Props> = ({ address_to_address }) => {
  return (
    <div className="AddressVehicleDetailsBubbleInfo">
      <div className="LocationCell">
        <SearchResultPOIMarker />
        <H4 className="NoGutterBottom">{address_to_address.address_one}</H4>
      </div>
      <div className="Info">
        <Icon iconSize={32} icon="arrow-down" className="Icon" />
        <div className="Text">
          <H6 className="Pill">{address_to_address.distance}</H6>
          <H6 className="Pill NoGutterBottom">
            {address_to_address.traveltime}
          </H6>
        </div>
      </div>
      <div className="LocationCell">
        <SearchResultPOIMarker />
        <H4 className="NoGutterBottom">{address_to_address.address_two}</H4>
      </div>
    </div>
  );
};

export default AddressToAddressInfo;
